import React from 'react';
import { Box } from '@mui/material';

import styles from './TimeGutterHeader.module.scss';

export function TimeGutterHeader() {
  return <Box className={styles.timeGutterHeader} />;
}
